import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav ``;
const ItemList = styled.ul `
  display: flex;
  align-items: center;
`;
const Item = styled.li `
  display: flex;
  align-items: center;

  &::after {
    display: inline-block;
    border-left: 1px solid #b1b3b5;
    height: 16px;
    margin: 0 32px;
  }

  &:not(:last-child)::after {
    content: '';
  }
`;
const Link = styled.a `
  display: inline-block;
  color: #b1b3b5;
  ${fonts.helvetica.bold};
  font-size: 13px;
  height: 16px;
  line-height: 1em;
  text-decoration: none;
  text-underline-position: under;

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }

  &:hover {
    text-decoration: underline;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 14px;
  }
`;
const TopLinksStyles = {
    Container,
    Item,
    ItemList,
    Link,
};
export default TopLinksStyles;
